import React from 'react';
import { isDesktop } from 'bv';

import Layout from './layout';
import Betslip from './betslip';
import Cashout from './cashout';
import RightComponents from './right_components';

export default () => (
  <Layout>
    <Betslip />
    <Cashout />
    { isDesktop() && <RightComponents /> }
  </Layout>
);
